import { useTranslation } from 'react-i18next'
import { Wifi, WifiOff } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ConnectionIndicatorProps {
  isOnline: boolean
  isSyncing?: boolean
  className?: string
}

export function ConnectionIndicator({ isOnline, isSyncing = false, className }: ConnectionIndicatorProps) {
  const { t } = useTranslation('orders')

  if (isOnline && !isSyncing) {
    return (
      <div className={cn('flex items-center gap-1.5', className)}>
        <Wifi className="h-3.5 w-3.5 text-status-success hidden sm:block" />
        <span className="relative flex h-2 w-2 sm:hidden">
          <span className="h-2 w-2 rounded-full bg-status-success" />
        </span>
        <span className="text-xs text-status-success hidden sm:inline">{t('connection.online')}</span>
      </div>
    )
  }

  if (isOnline && isSyncing) {
    return (
      <div className={cn('flex items-center gap-1.5', className)}>
        <span className="relative flex h-2 w-2">
          <span className="absolute h-2 w-2 rounded-full bg-status-warning animate-ping opacity-75" />
          <span className="h-2 w-2 rounded-full bg-status-warning" />
        </span>
        <span className="text-xs text-status-warning hidden sm:inline">{t('connection.syncing')}</span>
      </div>
    )
  }

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <WifiOff className="h-3.5 w-3.5 text-status-error" />
      <span className="relative flex h-2 w-2">
        <span className="absolute h-2 w-2 rounded-full bg-status-error animate-ping opacity-75" />
        <span className="h-2 w-2 rounded-full bg-status-error" />
      </span>
      <span className="text-xs text-status-error">{t('connection.offline')}</span>
    </div>
  )
}
